import "../myReports/style.scss";
import SubNavigationTabs from "../../components/common/subNavigationTabs";
import ReportTab from "../myReports/reportTab";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {clearActiveReport, getTableauReport} from "../../actions/reports";
import {useNavigate} from "react-router-dom";
import ShowReport from "../../components/showReport";

export const route = '/status-reports'

const REPORT_INFO = {
  title: 'TES Status of Invited Schools'
}

const StatusReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeReport) {
      dispatch(getTableauReport('getStatusReport', false));
    }
  });

  const activeReport = useSelector((state) => state.reports.activeReport);

  const onClearReport = async () => {
    await dispatch(clearActiveReport());
    await navigate('/reports-gallery');
  };

  return (
    <div className="reports-container">
      {activeReport && <ShowReport reportInfo={REPORT_INFO} activeReport={activeReport} onReportClear={onClearReport}/>}
    </div>
  );
}

export default StatusReport;